import { render } from "./FunctionHelp.vue?vue&type=template&id=4b1ff89a&scoped=true&ts=true"
import script from "./FunctionHelp.vue?vue&type=script&lang=ts"
export * from "./FunctionHelp.vue?vue&type=script&lang=ts"

import "./FunctionHelp.vue?vue&type=style&index=0&id=4b1ff89a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1ff89a"]])

export default __exports__